import React from "react";
import {
  Lightbulb,
  Users,
  Target,
  TrendingUp,
  CheckCircle2,
} from "lucide-react";

import {
  aboutData,
  innovationData,
} from "../data/mockData";

const AboutSection = () => {
  const iconMap = {
    Lightbulb,
    TrendingUp,
    Users,
  };

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container">

        {/* =====================================================
            SOBRE O IMA
        ===================================================== */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">
            {aboutData.title}
          </h2>

          <div className="max-w-4xl mx-auto space-y-4">
            <p className="body-large text-gray-700 leading-relaxed">
              {aboutData.description}
            </p>

            {aboutData.complementaryDescription && (
              <p className="body-large text-gray-700 leading-relaxed">
                {aboutData.complementaryDescription}
              </p>
            )}
          </div>
        </div>

        {/* =====================================================
            MISSÃO
        ===================================================== */}
        <div className="bg-white p-8 rounded-2xl shadow-sm mb-12 text-center">
          <Target className="w-12 h-12 text-accent-text mx-auto mb-4" />

          <h3 className="heading-3 mb-4">
            Nossa Missão
          </h3>

          <p className="body-large text-accent-text font-medium max-w-3xl mx-auto">
            {aboutData.mission}
          </p>
        </div>

        {/* =====================================================
            INOVAÇÃO QUE GERA DESENVOLVIMENTO
        ===================================================== */}
        <div
          className="
            bg-gradient-to-r
            from-accent-wash
            to-transparent
            p-8
            md:p-10
            rounded-2xl
            mb-16
          "
        >
          <div className="flex flex-col md:flex-row md:items-start gap-5">
            {/* Ícone */}
            <div
              className="
                w-14
                h-14
                shrink-0
                bg-white
                rounded-2xl
                flex
                items-center
                justify-center
                shadow-sm
              "
            >
              <Lightbulb className="w-7 h-7 text-accent-text" />
            </div>

            {/* Conteúdo */}
            <div className="flex-1">
              <h3 className="heading-3 mb-3">
                {innovationData.title}
              </h3>

              <p className="body-medium text-gray-700 leading-relaxed mb-3 max-w-4xl">
                {innovationData.description}
              </p>

              <p className="body-medium text-gray-700 font-medium mb-6">
                Por isso, o IMA desenvolve e executa iniciativas voltadas para:
              </p>

              <div className="grid md:grid-cols-2 gap-x-8 gap-y-4">
                {innovationData.initiatives.map((initiative, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3"
                  >
                    <CheckCircle2
                      className="
                        w-5
                        h-5
                        text-accent-text
                        shrink-0
                        mt-0.5
                      "
                    />

                    <span className="text-sm md:text-base text-gray-700 leading-relaxed">
                      {initiative}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* =====================================================
            INOVAÇÃO / DESENVOLVIMENTO / CONEXÃO
        ===================================================== */}
        <div className="grid md:grid-cols-3 gap-8">
          {aboutData.values.map((value, index) => {
            const IconComponent =
              iconMap[value.icon] || Lightbulb;

            return (
              <div
                key={index}
                className="innovation-card text-center group"
              >
                <div
                  className="
                    w-16
                    h-16
                    bg-accent-wash
                    rounded-full
                    flex
                    items-center
                    justify-center
                    mx-auto
                    mb-6
                    group-hover:bg-accent-primary/20
                    transition-colors
                  "
                >
                  <IconComponent className="w-8 h-8 text-accent-text" />
                </div>

                <h3 className="heading-3 mb-3">
                  {value.title}
                </h3>

                <p className="body-medium text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default AboutSection;